const EDITOR_CAPABILITIES = {
    tools: ['placemark', 'measure', 'path', 'polygon', 'label', 'sketch', 'comment'],
    canPrint: true,
    canDownload: true,
    canEditProject: true,
    canManageSharing: true,
    isClientViewer: false,
};
const CLIENT_VIEWER_CAPABILITIES = {
    // "Limited to comments, sketches, and printouts."
    tools: ['sketch', 'comment'],
    canPrint: true,
    canDownload: false,
    canEditProject: false,
    canManageSharing: false,
    isClientViewer: true,
};
export function capabilitiesForRole(role) {
    return role === 'client_viewer' ? CLIENT_VIEWER_CAPABILITIES : EDITOR_CAPABILITIES;
}
// Entitlement axis helpers — read the gate's own verdict rather than
// re-deriving it from a status string. accessLevel is a fetch-time snapshot; a
// live demo (`demo`) may need a real-time countdown refinement for the exact
// expiry tick, but the entitlement CLASS comes from here.
export const hasFullAccess = (accessLevel) => accessLevel === 'full';
export const isLiveDemo = (accessLevel) => accessLevel === 'demo';
// Lapsed demo: view-only low-resolution "scouting" access.
export const isScouting = (accessLevel) => accessLevel === 'scouting';
// Can the user see layers at all (any grade)? none = still building / no access.
export const canViewLayers = (accessLevel) => accessLevel != null && accessLevel !== 'none';
// Compose BOTH axes, mirroring OPA. Export/download of GIS data needs an
// editor-grade role AND full entitlement — a demo/scouting project never
// exports, whatever the role. Everything else is role-driven.
export function capabilitiesFor(role, accessLevel) {
    const base = capabilitiesForRole(role);
    return {
        ...base,
        canDownload: base.canDownload && hasFullAccess(accessLevel),
    };
}
// Who may change one saved drawing. Every editor-grade role may change
// anything in the project; a client viewer may save into any folder but may
// only change what they drew themselves, so an artifact carrying no author on
// the wire reads as someone else's. One reading, shared by the folder tree and
// the Get Info dialogs, and hide-not-rebuild like the rest of this file: the
// server is still the enforcer.
export function canModifyArtifact(artifact, currentUserId, isClientViewer) {
    if (!isClientViewer)
        return true;
    return !!(artifact === null || artifact === void 0 ? void 0 : artifact.author) && artifact.author.userId === currentUserId;
}
// Convenience over the project object; a missing project or role (demo
// previews, legacy responses) keeps today's editor behavior. Composes the
// entitlement axis when accessLevel is present.
export function capabilitiesForProject(project) {
    return capabilitiesFor(project === null || project === void 0 ? void 0 : project.myRole, project === null || project === void 0 ? void 0 : project.accessLevel);
}
